<template>
  <div class="product-item" @click="goToDetail(product.id)">
    <div class="product-info">
      <p class="product-list-title">{{ product.title }}</p>
      <p class="product-list-date">{{ product.date }}</p>
    </div>
    <div class="product-image">
      <img :src="product.image" :alt="product.title">
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductItem",
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToDetail(id) {
      this.$router.push({ name: 'ProductDetail', params: { id } });
    }
  }
}
</script>

<style scoped>

.product-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 0.1vw solid #ccc; /* 横线分隔 */
  padding: 15px 0;
}
.product-item :hover {
  background-color: #f2f2f2;
}
.product-info {
  flex: 1;
  text-align: left;
}
.product-list-title {
  color: #333333;
  font-size: 4.5vw;
  margin-bottom: 20px;
}
.product-list-date {
  font-size: 3.5vw;
  line-height: 3.5vw;
  color: #999;
  vertical-align: bottom;
}
.product-image img {
  max-width: 15vw; /* 或其他你想要的宽度 */
  height: auto;
  border-radius: 5px;
}
@media (min-width: 768px) {
  .product-item {
    border-bottom: 0.8px solid #ccc; /* 横线分隔 */
  }
  .product-list-title {
    color: #333333;
    font-size: 26px;
    margin-bottom: 20px;
  }
  .product-list-date {
    font-size: 20px;
    color: #999;
  }
  .product-image img {
    max-width: 80px; /* 或其他你想要的宽度 */
    height: auto;
    border-radius: 10px;
  }
}
</style>